import { LocalizedPipe } from 'src/app/shared/localized.pipe';
import { resourceText } from 'src/app/shared/services/localization';
import { CommonModule } from '@angular/common';
import { booleanAttribute, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { messageIcon, messageType } from '../message-type';

@Component({selector:'app-user-message', standalone:true, imports: [LocalizedPipe, CommonModule], templateUrl:'./user-message.component.html', styleUrls:['./user-message.component.scss']})
export class UserMessageComponent implements OnChanges {
  @Input() type = 'info';
  @Input() title = '';
  @Input() message = '';
  @Input() actionLabel = '';
  @Input() actionColor = 'primary';
  @Input({transform:booleanAttribute}) dismissible = true;
  @Input({transform:booleanAttribute}) busy = false;
  @Output() close = new EventEmitter<void>();
  @Output() action = new EventEmitter<void>();
  hidden = false;
  constructor(public globalService: GlobalService) {}
  get severity() { return messageType(this.type); }
  get icon() { return messageIcon(this.severity); }
  get heading() {
    if (this.title) return this.title;
    const keys = {"error": "ACTION_NEEDED", "warning": "PLEASE_REVIEW", "confirmation": "PLEASE_CONFIRM", "info": "GOOD_TO_KNOW", "success": "COMPLETE"};
    return this.globalService.Get(keys[this.severity]);
  }
  ngOnChanges() { this.hidden = false; }
  dismiss() { if (this.busy) return; this.hidden = true; this.close.emit(); }
}
